import { ThemeEvents } from "@theme/events";
const cartCountSelector = "[data-cart-count]";
const cartCountA11ySelector = "[data-cart-count-a11y]";
const cartBadgeSelector = "[data-cart-badge]";
const headerCartSelector = "[data-header-cart]";
const drawerSelector = "cart-drawer-component";
let pending = false;
async function refresh() {
  if (pending) return;
  pending = true;
  try {
    const response = await fetch(`${Theme.routes.cart_url}.js`, {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) return;
    const cart = await response.json();
    const count = String(cart.item_count);
    for (const el of document.querySelectorAll(
      cartCountSelector
    )) {
      el.textContent = count;
    }
    for (const el of document.querySelectorAll(
      cartCountA11ySelector
    )) {
      const text = el.textContent ?? "";
      const lastColon = text.lastIndexOf(":");
      el.textContent = lastColon >= 0 ? `${text.slice(0, lastColon + 1)} ${count}` : count;
    }
    for (const el of document.querySelectorAll(
      cartBadgeSelector
    )) {
      el.classList.toggle("hidden", cart.item_count === 0);
    }
  } catch {
  } finally {
    pending = false;
  }
}
let drawerPromise = null;
let sectionInjected = false;
let injectPromise = null;
function loadDrawer() {
  drawerPromise ??= import("@theme/cart-drawer");
  return drawerPromise;
}
async function injectCartDrawer() {
  if (sectionInjected) return;
  injectPromise ??= _injectCartDrawer();
  return injectPromise;
}
async function _injectCartDrawer() {
  const template = document.getElementById(
    "cart-drawer-template"
  );
  if (!template) return;
  const fragment = template.content.cloneNode(true);
  for (const oldScript of fragment.querySelectorAll("script")) {
    const newScript = document.createElement("script");
    for (let i = 0; i < oldScript.attributes.length; i++) {
      const attr = oldScript.attributes[i];
      newScript.setAttribute(attr.name, attr.value);
    }
    newScript.textContent = oldScript.textContent;
    oldScript.replaceWith(newScript);
  }
  const section = fragment.querySelector(
    '[id^="shopify-section-"]'
  );
  if (!section) return;
  document.body.appendChild(section);
  await Promise.all([
    customElements.whenDefined("cart-form-component"),
    customElements.whenDefined("quantity-selector-component")
  ]);
  sectionInjected = true;
}
function getDrawerElement() {
  return document.querySelector(
    drawerSelector
  );
}
async function openDrawer() {
  await loadDrawer();
  await Promise.resolve();
  if (!sectionInjected) {
    await injectCartDrawer();
  }
  const drawer = getDrawerElement();
  drawer?.show?.();
}
function attachAnchor(anchor) {
  if (anchor.dataset.cartDrawerBound === "true") return;
  anchor.dataset.cartDrawerBound = "true";
  const prefetch = () => void loadDrawer();
  anchor.addEventListener("mouseenter", prefetch, { once: true });
  anchor.addEventListener("focus", prefetch, { once: true });
  anchor.addEventListener("click", (event) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
      return;
    }
    event.preventDefault();
    void openDrawer();
  });
}
function attachAnchors() {
  for (const anchor of document.querySelectorAll(
    headerCartSelector
  )) {
    attachAnchor(anchor);
  }
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", attachAnchors, { once: true });
} else {
  attachAnchors();
}
document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  void refresh();
});
